import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () =>
    import ('@/containers/DefaultContainer')

// Views
const Consultas = () =>
    import ('@/views/Consultas')
const RealizarPago = () =>
    import ('@/views/RealizarPago')
const PruebasPago = () =>
    import ('@/views/PruebasPago')


Vue.use(Router)

export default new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
        path: '/',
        redirect: '/consulta',
        name: 'Home',
        component: DefaultContainer,
        children: [{
                path: 'consulta',
                name: 'consulta',
                component: Consultas
            },
            {
                path: 'realizar-pago/:id',
                name: 'realizarPago',
                component: RealizarPago
            },
            {
                path: 'pruebas-pago',
                name: 'pruebasPago',
                component: PruebasPago
            }
        ]
    }]
})